import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { commonService, COMMON_ENDPOINTS } from "services/commonService"

interface EmploymentStatus {
  employmentStatusId: number
  description: string
  isActive: boolean
  isDeleted: boolean
}

export const usePayrollStaffCategories = () => {
  const { data, isLoading, isError } = useQuery<IBaseRes<EmploymentStatus[]>>({
    queryKey: [COMMON_ENDPOINTS.GET_EMPLOYMENT_STATUS],
    queryFn: () => commonService.getEmploymentStatus(),
  })

  return {
    isLoading,
    isError,
    options: [
      { label: "All staff", value: "All", key: 5 },
      ...(data?.data || [])
        .filter((status) => status.isActive && !status.isDeleted)
        .map((status) => ({
          label: status.description,
          value: status.description,
          key: status.employmentStatusId,
        })),
    ],
  }
}
